import React from 'react';
import moment from 'moment';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import Calendar from 'react-calendar';
import {
Popover, Button,
} from 'evergreen-ui';
import { BsChevronDown } from 'react-icons/bs';
import colors from '../../../config/colors.json';
import {
	Container,
	StyledPane,
	InputGroup,
} from './style';

const DateSelect = ({
 start, setStart, end, setEnd,
}) => {
	const rangeDate = [start, end];
	const btnClass = 'text-dark';
	const btnStyle = {
		padding: '13px 10px 13px 13px',
		display: 'flex',
		justifyContent: 'space-between',
		width: '117px',
		fontSize: '14px',
		borderRadius: '8px',
		backgroundColor: '#fff',
		border: `1px solid ${colors.lightGrey15}`,
		outline: 'none',
		boxShadow: '0 0 0 transparent',
	};

	return (
		<Container>
			<InputGroup>
				<label>Início</label>
				<Popover
					content={(
						<StyledPane
							width={240}
							height="auto"
							display="flex"
							alignItems="right"
							justifyContent="right"
							flexDirection="column"
						>
							<Calendar
								locale="pt-BR"
								calendarType="Hebrew"
								onChange={date => setStart(date)}
								value={start}
								returnValue="start"
								maxDate={new Date()}
								prev2Label={null}
								next2Label={null}
								showNeighboringMonth={false}
								prevLabel={<IoIosArrowBack />}
								nextLabel={<IoIosArrowForward />}
							/>
						</StyledPane>
					)}
				>
					<Button
						className={btnClass}
						style={btnStyle}
						appearance="minimal"
						marginRight={30}
					>
						{moment(start).format('DD/MM/YYYY')}
						<BsChevronDown />
					</Button>
				</Popover>
			</InputGroup>
			<InputGroup>
				<label>Fim</label>
				<Popover
					content={(
						<StyledPane
							width={240}
							height="auto"
							display="flex"
							alignItems="center"
							justifyContent="center"
							flexDirection="column"
						>
							<Calendar
								minDate={start}
								maxDate={new Date()}
								allowPartialRange
								returnValue="end"
								onChange={date => setEnd(date)}
								value={rangeDate}
								prev2Label={null}
								next2Label={null}
								showNeighboringMonth={false}
								prevLabel={<IoIosArrowBack />}
								nextLabel={<IoIosArrowForward />}
							/>
						</StyledPane>
					)}
				>
					<Button
						className={btnClass}
						style={btnStyle}
						appearance="minimal"
					>
						{moment(end).format('DD/MM/YYYY')}
						<BsChevronDown />
					</Button>
				</Popover>
			</InputGroup>
		</Container>
	);
};

export default DateSelect;
